

<em class="icon-sort-alpha-desc" *ngIf="state==='up'"></em>
<em class="icon-sort-alpha-asc"  *ngIf="state==='down'"></em>
